import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useController, useFormContext, } from 'react-hook-form';
import Styles from './styles';
function SearchField({ name }) {
    const { control, getValues, setValue } = useFormContext();
    const { field: { onChange } } = useController({
        name,
        control,
    });
    const value = getValues(name);
    const clearValue = () => {
        console.log('Clearing');
        setValue(name, '');
    };
    return (_jsxs(Styles.Element, { children: [_jsx("label", { htmlFor: "search-input", className: "sr-only", children: "Search for activities" }), _jsx("input", { type: "search", id: "search-input", name: name, spellCheck: false, className: "search-bar__input", value: `${value}`, onChange: onChange, placeholder: "Search..." }), _jsx("button", { className: "search-bar__button", type: "submit", "aria-label": "Search", children: _jsx("svg", { children: _jsx("use", { xlinkHref: "#icon--explore" }) }) })] }));
}
export default SearchField;
